import * as yup from 'yup';
import { cpf, cnpj } from 'cpf-cnpj-validator';
import { avaliarIe } from '../shared/utils/inscricaoEstadual';

export const ClienteDetalheSchema = yup.object().shape({
  Nome: yup
    .string()
    .required('Campo Obrigatório!')
    .min(4, 'O Campo deve ter no mínimo 4 caracteres'),
  CpfCnpj: yup.string()
    .required('Campo Obrigatório!')
    .matches(/^[0-9.,-/]*$/, 'Apenas caracteres numéricos são permitidos')
    .transform((value) => value.replace(/[^\d]/g, ''))
    .test('len', 'Deve ter 11 ou 14 dígitos', (val) => {
      return val ? val.length === 11 || val.length === 14 : false;
    })
    .test('cpf-cnpj-valido', 'CPF/CNPJ inválido', (val) => {
      // val ja vem so com digitos (transform acima). Valida os digitos verificadores:
      // 11 -> CPF, 14 -> CNPJ. Outros tamanhos ficam por conta do teste 'len'.
      if (!val) return true;
      if (val.length === 11) return cpf.isValid(val);
      if (val.length === 14) return cnpj.isValid(val);
      return true;
    }),
  // O campo continua opcional: quem não tem IE (ou é isento) deve poder salvar -
  // a nota sai com indIEDest 2/9 e CSOSN 102, que é o correto.
  //
  // O que este teste faz é impedir IE de SP que não fecha o dígito verificador,
  // porque essa vira rejeição 210 na emissão, longe daqui e sem dizer o motivo.
  // Só SP bloqueia; nos outros estados o aviso aparece no campo sem travar o
  // Salvar (ver avaliarIe). Só vale quando o documento é CNPJ - em CPF este mesmo
  // campo guarda o RG.
  RgIe: yup.string().notRequired().test(
    'ie-digito-verificador',
    'Inscrição Estadual inválida',
    function (valor) {
      const { CpfCnpj, Estado } = this.parent;
      const { mensagem, bloqueia } = avaliarIe(valor ?? '', Estado, CpfCnpj);

      if (!bloqueia) return true;

      return this.createError({ path: this.path, message: mensagem });
    }
  ),
  RazaoSocial: yup.string().min(4, 'O Campo deve ter no mínimo 4 caracteres').required('Campo Obrigatório!'),
  Cep: yup.string().required('Campo Obrigatório'),
  GrupoCliente: yup.string().required('Campo Obrigatório'),
  Endereco: yup.string().required('Campo Obrigatório!'),
  Numero: yup.number().typeError('Por favor, insira um número válido'), //.required("Campo Obrigatório!"),
  Bairro: yup.string().required('Campo obrigatório'),
  Cidade: yup.string().required('Campo obrigatório'),
  Estado: yup.string().required('Campo obrigatório'),
  Email: yup.string().notRequired(),
  Fornecedor: yup.string()
    .test('at-least-one-sim', 'Um campo deve conter SIM obrigatóriamente', function (value) {
      const { Cliente, Transportadora } = this.parent;
      // Se nenhum for 'SIM', a validação falha
      if ((Cliente === 'N' || !Cliente) && (Transportadora === 'N' || !Transportadora) && (value === 'N' || !value)) {
        return this.createError({ message: 'Um campo deve conter SIM obrigatóriamente' });
      }
      return true;
    }),
  Transportadora: yup.string()
    .test('at-least-one-sim', 'Um campo deve conter SIM obrigatóriamente', function (value) {
      const { Fornecedor, Cliente } = this.parent;
      // Se nenhum for 'SIM', a validação falha
      if ((Fornecedor === 'N' || !Fornecedor) && (Cliente === 'N' || !Cliente) && (value === 'N' || !value)) {
        return this.createError({ message: 'Um campo deve conter SIM obrigatóriamente' });
      }
      return true;
    }),
  Cliente: yup.string()
    .test('at-least-one-sim', 'Um campo deve conter SIM obrigatóriamente', function (value) {
      const { Fornecedor, Transportadora } = this.parent;
      // Se nenhum for 'SIM', a validação falha
      if ((Fornecedor === 'N' || Fornecedor == undefined) && (Transportadora === 'N' || Transportadora == undefined) && (value === 'N' || value == undefined)) {
        return this.createError({ message: 'Um campo deve conter SIM obrigatóriamente' });
      }
      return true;
    }),
  Telefone: yup.string().notRequired(),
  Celular: yup.string().notRequired(),
  ClienteAtivo: yup.string().required('Campo obrigatório!')
})    